import { render, staticRenderFns } from "./formulario_consulta_campo_text.vue?vue&type=template&id=0335e68f&scoped=true&"
import script from "./formulario_consulta_campo_text.vue?vue&type=script&lang=js&"
export * from "./formulario_consulta_campo_text.vue?vue&type=script&lang=js&"
import style0 from "./formulario_consulta_campo_text.vue?vue&type=style&index=0&id=0335e68f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0335e68f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
